module.exports = __webpack_public_path__ + "static/media/gJunior_Intro.02c69a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/gJunior_Intro.png
// module id = 716
// module chunks = 21